import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";

export interface NotAuthorizedRouteProps {
    redirect?: string;
    component: JSX.Element;
}

export function NotAuthorizedRoute(props: NotAuthorizedRouteProps): JSX.Element {
  const { defaultNotAuthorizedRouteRedirect, user } = useAuth()

  if (!user) {
    return props.component
  } else {
    return <Navigate to={props.redirect ?? defaultNotAuthorizedRouteRedirect} />
  }
}
